import React, { useState } from 'react';
import CheckboxComponent from '../../components/CheckboxComponent';
import TextareaComponent from '../../components/TextareaComponent';
import AiTargetingSuggest from '../../components/AiTargetingSuggest';

import '../../assets/scss/sectionSix.scss';

function fieldToneClass(inferredByField, name) {
	if (!inferredByField || !(name in inferredByField)) {
		return '';
	}
	return inferredByField[name] ? 'is-inferred' : 'is-from-text';
}

const SectionSix = ({ register, setValue, getValues }) => {
	const [inferredByField, setInferredByField] = useState({});
	const hasTones = Object.keys(inferredByField).length > 0;

	return (
		<div className='sectionSix malretting flex-column'>
			<AiTargetingSuggest
				setValue={setValue}
				getValues={getValues}
				onInferredChange={setInferredByField}
			/>
			{hasTones ? (
				<div className='ai-field-legend' aria-label='Fargeforklaring'>
					<span className='ai-field-legend__item is-from-text'>
						<i aria-hidden='true' />
						Fra stillingsteksten
					</span>
					<span className='ai-field-legend__item is-inferred'>
						<i aria-hidden='true' />
						AI-forslag (ikke tydelig i teksten)
					</span>
				</div>
			) : null}
			<div className='flex-row geo'>
				<TextareaComponent
					label='Geografi'
					name='malGeo'
					register={register}
					className={`malGeo ${fieldToneClass(inferredByField, 'malGeo')}`}
					rows={2}
				/>
				<TextareaComponent
					label='Alder'
					name='geoAge'
					register={register}
					className={`geoAge ${fieldToneClass(inferredByField, 'geoAge')}`}
					rows={2}
				/>
			</div>
			<TextareaComponent
				label='Ønsker / krav til utdanning og / eller arbeidserfaring'
				name='wishesDemands'
				className={`wishesDemands ${fieldToneClass(
					inferredByField,
					'wishesDemands'
				)}`}
				rows={2}
				register={register}
			/>
			<TextareaComponent
				label='Ferdigheter / stillingstitler'
				name='skillsTitles'
				className={`skillsTitles ${fieldToneClass(
					inferredByField,
					'skillsTitles'
				)}`}
				rows={2}
				register={register}
			/>
			<TextareaComponent
				label='Bedrifter hvor potensielle kandidater jobber i dag'
				name='companies'
				className={`companies ${fieldToneClass(inferredByField, 'companies')}`}
				rows={2}
				register={register}
			/>
			<TextareaComponent
				label='Bransje / interesser'
				name='industryInterests'
				className={`industryInterests ${fieldToneClass(
					inferredByField,
					'industryInterests'
				)}`}
				rows={2}
				register={register}
			/>
			<CheckboxComponent
				label='Ja, hybrid/hjemmekontor er mulig'
				name='hybridHome'
				value='hybridHome'
				className='hybridHome'
				register={register}
			/>
		</div>
	);
};

export default SectionSix;
